import { gql } from '@apollo/client';
import ErrorResultFragment from "../../../fragments/ErrorResult";

const UPDATE_ACCOUNT_SETTINGS = gql`
  mutation UpdateAccountSettings(
    $userId: Int!
    $model: UpdateAccountSettingsInput
  ) {
    companyAdminContext {
      users {
        updateAccountSettings(userId: $userId, model: $model) {
          errorResult {
            ...ErrorResultFields
          }
          success
          addressChangeRequestSent
          addressesUpdated
          user {
            companyId
            userId
            username
            firstname
            lastname
            avatar
            #roleName
            #groupBreadcrumbs {
            #  groups {
            #    groupId
            #    name
            #  }
            #}
            subscriptionLevel
          }
        }
      }
    }
  }
  ${ErrorResultFragment}
`;

export default UPDATE_ACCOUNT_SETTINGS;
